<script lang="ts" setup>
import './modal-cookie.scss';
import i18n from '@/translations';
import { useModalsStore } from '@/stores/modals';
import { useAlertsStore } from '@/stores/alerts';
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import config, { gtag } from '@/config';
import { getStaticImages } from '@/utils';

import { useLocalizationStore } from '@/stores/localization';

const { toggleModal, closeModal } = useModalsStore();
const { openMessage } = useAlertsStore();
const { location } = storeToRefs(useLocalizationStore());
const router = useRouter();

const toggles = ref([{ name: "essential", value: true },{ name: "marketing", value: false },{ name: "static", value: false }]);
const manageCookies = ref(false);

const isUSA = computed(() => {
    return location?.value === 'US';
})

const links = computed(() => {
    return {policy: `<a href='../privacy-policy'>${i18n.global.t('textpages.policytitle')}</a>`, terms: `<a href='../terms'>${i18n.global.t('textpages.termstitle')}</a>`};
})

function redirect(){
    window.location.href = 'http://www.google.com';
}

function accept(all: boolean){
    if(window.localStorage) {
        let list: any;
        if(all){
            list = toggles.value;
            for (let i = 0; i < list.length; i++) {
                list[i].value = true;
            }
        } else {
            list = toggles.value
        }

        // Set Marketing to granted if true
        // if(toggles.value[1].value){
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'ad_user_data': 'granted',
                'ad_personalization': 'granted',
                'analytics_storage': 'granted'
            });
        // }

        window.localStorage.setItem(`${config.StorageKey}.cookies`, JSON.stringify(list));
        closeModal('cookiee')
    }
}

</script>

<template src="./modal-cookie.html"></template>